document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-ks-menu-toggle]');
  const menu = document.querySelector('[data-ks-mobile-menu]');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    menu.classList.toggle('is-open');
  });
});